import { useState } from 'react';
import { CARIMBO } from 'virtual:carimbo-build';
import { useAuth } from '../context/AuthContext';

/* ══ O QUE ESTÁ NA TELA SE IDENTIFICA — E SE MEDE ════════════════════

   26/08/2026. O carimbo nasceu de um dia perdido: o V993 estava correto
   no Git, no servidor e dentro do container, e a tela mostrava outra
   coisa. Sem nada na tela dizendo qual build está rodando, não havia
   como separar "o código está errado" de "o navegador está com código
   velho" — e as duas hipóteses custam rodadas diferentes.

   O PAINEL veio no mesmo dia, por um segundo motivo: a medição seguinte
   dependia de colar JavaScript no console do navegador, e o Chrome
   bloqueia colagem no console por padrão. Pedir isso a quem opera o
   sistema transforma uma medição de dez segundos numa aula.

   Então a medição mora aqui. Clica no carimbo, ele mede e mostra.

   ⚠ MEDE ANTES DE ABRIR. `elementFromPoint` devolve quem está por cima
   num ponto — com o painel já na tela, devolveria o painel. Por isso o
   texto é calculado no clique e só depois guardado no estado. */

function medir() {
  const L = [];
  const cx = (e) => String(e.className || e.tagName).trim().slice(0, 38);
  const g = (e) => {
    const s = getComputedStyle(e);
    const r = e.getBoundingClientRect();
    return `${s.position} z=${s.zIndex} | ${Math.round(r.left)},${Math.round(r.top)} `
      + `${Math.round(r.width)}x${Math.round(r.height)} | fundo=${s.backgroundColor}`;
  };

  L.push(`build   ${CARIMBO}`);
  L.push(`tela    ${window.innerWidth}x${window.innerHeight}`);

  const tela = document.querySelector('.conf-tela');
  if (!tela) {
    L.push('');
    L.push('conf-tela FORA do DOM — abra o Nova Expedicao antes de medir.');
    return L.join('\n');
  }

  L.push(`modal   ${g(tela)}`);
  const caixa = tela.firstElementChild;
  if (caixa) L.push(`caixa   ${g(caixa)}`);

  for (const alvo of ['.sbn', '.app-topbar']) {
    const e = document.querySelector(alvo);
    if (e) L.push(`${alvo.padEnd(7)} ${g(e)}`);
  }

  /* ⚠ MEDIR NA CAIXA, NAO NO ESCURECIDO (26/08/2026).

     A primeira versao media nos cantos da `.conf-tela`, que ocupa a
     tela inteira: o "canto superior esquerdo" caia dentro da sidebar
     (que legitimamente esta ali) e o "meio do topo" caia em y=10, ACIMA
     da topbar, que comeca em y=13. O teste que deveria comparar modal
     contra topbar nunca encostou na topbar.

     Agora o ponto e o centro da area onde os dois SE SOBREPOEM. Se nao
     ha sobreposicao, diz isso em vez de medir o vazio. */
  const rCaixa = (caixa || tela).getBoundingClientRect();
  for (const alvo of ['.sbn', '.app-topbar']) {
    const outro = document.querySelector(alvo);
    if (!outro) continue;
    const b = outro.getBoundingClientRect();
    const x = (Math.max(rCaixa.left, b.left) + Math.min(rCaixa.right, b.right)) / 2;
    const y = (Math.max(rCaixa.top, b.top) + Math.min(rCaixa.bottom, b.bottom)) / 2;
    if (Math.max(rCaixa.left, b.left) >= Math.min(rCaixa.right, b.right)
      || Math.max(rCaixa.top, b.top) >= Math.min(rCaixa.bottom, b.bottom)) {
      L.push(`vs ${alvo}: nao se sobrepoem`);
      continue;
    }
    const emCima = document.elementFromPoint(x, y);
    L.push(`vs ${alvo}: por cima esta ${emCima ? cx(emCima) : '(nada)'}`);
  }

  /* Ancestral que cria contexto de empilhamento prende o z-index do
     modal dentro dele — e a explicacao possivel para 200 perder de 100. */
  const presos = [];
  let a = tela.parentElement;
  while (a && a !== document.body) {
    const s = getComputedStyle(a);
    const causas = [
      /* ⚠ POSITION + Z-INDEX PRIMEIRO, E ANIMATION. A primeira versao
         desta lista nao tinha nenhum dos dois e respondeu "ancestrais
         que prendem: nenhum" com o modal preso — quem prendia era o
         `.fade-transicao`, por `animation-fill-mode: both`. */
      (s.position !== 'static' && s.zIndex !== 'auto') && `position:${s.position} z=${s.zIndex}`,
      (s.animationName && s.animationName !== 'none'
        && /both|forwards/.test(s.animationFillMode)) && `animation:${s.animationName} (${s.animationFillMode})`,
      s.transform !== 'none' && 'transform',
      s.filter !== 'none' && 'filter',
      s.backdropFilter && s.backdropFilter !== 'none' && 'backdrop-filter',
      s.opacity !== '1' && `opacity:${s.opacity}`,
      s.willChange !== 'auto' && `will-change:${s.willChange}`,
      s.contain !== 'none' && `contain:${s.contain}`,
      s.isolation !== 'auto' && 'isolation',
      s.perspective !== 'none' && 'perspective',
      s.mixBlendMode !== 'normal' && 'mix-blend-mode',
    ].filter(Boolean);
    if (causas.length) presos.push(`${cx(a)} {${causas.join(', ')}}`);
    a = a.parentElement;
  }
  L.push(`ancestrais que prendem: ${presos.length ? presos.join(' / ') : 'nenhum'}`);

  return L.join('\n');
}

export default function CarimboBuild() {
  const { isMaster } = useAuth();
  const [texto, setTexto] = useState(null);
  const [copiado, setCopiado] = useState(false);

  const abrir = () => { setTexto(medir()); setCopiado(false); };

  /* ⚠ SÓ PARA O MASTER (26/08/2026, pedido do Juan).

     O carimbo e o painel são ferramenta de quem desenvolve e opera o
     sistema. Quem confere peça no galpão não tem o que fazer com a hora
     do build nem com o z-index da sidebar — e uma marca d'água no canto
     de uma tela de trabalho só ocupa atenção.

     `isMaster` vem do AuthContext, o mesmo sinal que o backend devolve
     em `/acessos` e que aparece no console como `master=true`. Não é
     checagem de segurança: não há nada a proteger aqui, só medida de
     tela. É filtro de relevância.

     ⚠ A SAÍDA VEM DEPOIS DOS HOOKS. `useState` acima e `return null`
     abaixo: invertido, o React trocaria a quantidade de hooks entre um
     render e outro assim que o `isMaster` chegasse da rede, e derrubaria
     a árvore inteira. */
  if (!isMaster) return null;

  /* `execCommand` e nao `navigator.clipboard`: a area de transferencia
     moderna so existe em origem segura, e o SGQ e servido por HTTP na
     rede interna — ali ela simplesmente nao esta disponivel. */
  const copiar = () => {
    const campo = document.getElementById('carimbo-texto');
    if (!campo) return;
    campo.select();
    try { document.execCommand('copy'); setCopiado(true); } catch { setCopiado(false); }
  };

  if (texto === null) {
    return (
      <button type="button" className="carimbo-build" onClick={abrir}
        title="Clique para medir a tela">
        {CARIMBO}
      </button>
    );
  }

  return (
    <div className="carimbo-painel">
      <div className="carimbo-painel-cab">
        <span className="carimbo-painel-t">Medicao da tela</span>
        <button type="button" className="carimbo-painel-b" onClick={copiar}>
          {copiado ? 'Copiado' : 'Copiar'}
        </button>
        <button type="button" className="carimbo-painel-b" onClick={() => setTexto(null)}>
          Fechar
        </button>
      </div>
      <textarea id="carimbo-texto" className="carimbo-painel-txt" readOnly value={texto} />
    </div>
  );
}
